import React, { useState, useEffect } from 'react'
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import CustomInput from '../../common/CustomInput';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from "yup"
import * as yup from 'yup'
import { useDispatch, useSelector } from 'react-redux';
import { CreateSize, UpdateSize } from '../../../redux/actions/productActions';
import { toast } from 'react-toastify';
import { RESET_ERROR } from '../../../redux/constants/userConstants';
import Reactotron from "reactotron-react-js"

const AddSize = ({ openModal, onCloseModal, data, setActiveData, title }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const { newsize, error } = useSelector(state => state.product)

    const schema = yup.object({
        name: yup.string()
            .max(40, "Size name must be at most 40 characters")
            .required("Size name is required"),
    })

    const { register, handleSubmit, setFieldValue, control, formState: { errors }, reset, setValue, setError } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            name: '',
        }
    });

    const createsize = (datas) => {
        Reactotron.log(datas, "size data")
        setLoading(true)

        if (data) {
            const formData = new FormData();
            formData.append('name', datas.name);
            formData.append('id', data?._id);
            formData.append('status', data?.status);
            dispatch(UpdateSize(formData)).finally(() => setLoading(false));
        }
        else {
            const formData = new FormData();
            formData.append('name', datas.name);
            dispatch(CreateSize(formData)).finally(() => setLoading(false));
            reset()
        }
    }

    useEffect(() => {
        if (error) {
            dispatch({
                type: RESET_ERROR
            })
        }
    }, [error])

    useEffect(() => {
        if (data) {
            setValue("name", data?.name)
        }
    }, [data])

    const clearclose = () => {
        onCloseModal()
        reset()
    }

    return (
        <Modal isOpen={openModal} toggle={clearclose} size="lg">
            <ModalHeader toggle={clearclose}>
                <h5
                    className="modal-title f-w-600"
                    id="exampleModalLabel2"
                >
                    {title}
                </h5>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <CustomInput
                        fieldLabel='Size Name :'
                        control={control}
                        error={errors.name}
                        fieldName='name'
                    />
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    disabled={loading ? true : false}
                    color="primary"
                    onClick={handleSubmit(createsize)}
                >
                    {loading ? "Saving" : "Save"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default AddSize 